define('models/calendar/item/text-session',[
    'underscore', 'backbone', 'utils', 'markdown',
    // models
    'models/calendar/item'
], function(
    _, Backbone, U, markdown,
    // models
    MCalendarItem
) {

    var MTextSession = MCalendarItem.extend({
        defaults: function() {
            return {
                sup_name: "",
                sup_description: "",
                type: MTextSession.type,
                duration: 0,
                effort: 6,
                activity: null,
                calories: 0,
                steps: null, // FIXME to remove
                elevation: { unit: "", value: 0 },
                distance: { unit: "km", value: 0 },
            };
        },

        computeds: {
            distanceValue: {
                deps: ["distance"],
                get: function(distance) {
                    return distance ? distance.value : "";
                },
                set: function(value) {
                    var distance = this.get('distance') || {};
                    return {
                        distance: MTextSession.getDefaultDistance(value, distance.unit)
                    };
                }
            },
            distanceUnit: {
                deps: ["distance"],
                get: function(distance) {
                    return distance ? distance.unit : 'km';
                },
                set: function(unit) {
                    var distance = this.get('distance') || {};
                    return {
                        distance: MTextSession.getDefaultDistance(distance.value, unit)
                    };
                }
            },
            isFavorite: {
                deps: ["favorite"],
                get: function(favorite) {
                    return favorite ? true : false;
                },
                set: function(value) {
                    var favorite = value;
                    return {
                        favorite: value
                    };
                }
            },
        },

        getFavoriteData: function() {
            return _.pick(this.attributes, [
                'sup_name', 'sup_description', 'duration', 'activity',
                'calories', 'elevation', 'steps', 'effort',
            ]);
        },

        getDescription: function() {
            return this.get('sup_description');
        },

        getTruncatedDescription: function(maxChars) {
            maxChars = maxChars || 100;
            var description = this.get('sup_description');

            if (description.length >= maxChars) {
                description = description.substring(0, 100) + '...';
            }

            if (description) {
                description = description.replace(/\n/g,'<br>');
            }

            return description;
        },

        getActivity: function() {
            return this.get('activity');
        },

        getName: function() {
            return this.get('sup_name');
        },

        hasAdvancedDetails: function() {
            return this.get('activity') ||
                this.get('duration') ||
                this.get('calories');
        },

        setCalories: function(value) {
            return this.set('calories', value);
        },

        getCalories: function() {
            return this.get('calories');
        },

        getCalculatedCalories: function(activity, profile) {
            var duration = this.get('duration'),
                effort = this.get('effort'),
                zone = activity.get('zones')[effort] || 0,
                weight = profile.getWeightValue('kg');
            return Math.round(zone * (duration / 60) * weight) || 0;
        },

    }, {
        ///////////////////
        // Class statics //
        ///////////////////
        type: 'activity',
        getUnitObject: function(value, unit) {
            return {
                unit: unit,
                value: _.isUndefined(value) ? 0 : value
            };
        },

        getDefaultDistance: function(value, unit) {
            return MTextSession.getUnitObject(value, unit || 'km');
        },

    });

    return MTextSession;
});

